var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "separable" },
    [
      _vm.showModalInserirDocumentos
        ? _c("app-modal-inserir-documentos", {
            attrs: {
              titulo: _vm.tituloModal,
              protocolo: this.$route.params.idCadastro
            },
            on: { closeModal: _vm.closeModalDocumentos }
          })
        : _vm._e(),
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              conteudo: _vm.conteudoModal,
              isVTN: false,
              isImagem: _vm.isImagem,
              tituloDocumento: _vm.tituloDocumento
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.conversa
            ? _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v(_vm._s(_vm.mensagens.assunto))
                      ]),
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _vm._l(_vm.mensagens.mensagemList, function(
                            mensagem,
                            index
                          ) {
                            return _c(
                              "app-collapse",
                              {
                                key: mensagem.id,
                                attrs: {
                                  title:
                                    _vm.setPessoaNomeRazaoSocial(
                                      mensagem.remetente
                                    ) +
                                    " - " +
                                    _vm
                                      .moment(mensagem.dataEnviada)
                                      .add(+0, "hours")
                                      .locale("pt-br")
                                      .calendar(),
                                  collapsed:
                                    index <
                                    _vm.mensagens.mensagemList.length - 1
                                      ? "1"
                                      : "0"
                                }
                              },
                              [
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(mensagem.conteudo)
                                  }
                                }),
                                _vm.conversaVistoriaRemota
                                  ? _c(
                                      "div",
                                      [
                                        _vm.conversa &&
                                        index === 0 &&
                                        !_vm.conversa.isPossivelResponder
                                          ? _c(
                                              "app-documentos-posse-mansa-e-pacifica",
                                              {
                                                attrs: {
                                                  conversa: _vm.conversa,
                                                  tipoCadastro:
                                                    _vm.processo.tipo.codigo,
                                                  mensagemOutros:
                                                    _vm.mensagemOutros
                                                }
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.conversa &&
                                _vm.conversaNotificacaoDocumentoInvalido &&
                                _vm.conversa.status === "ABERTA" &&
                                !_vm.conversaVistoriaRemota
                                  ? _c("p", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "click",
                                          on: { click: _vm.showModalDocumentos }
                                        },
                                        [_vm._v("Clique aqui")]
                                      ),
                                      _vm._v(" para inserir os documentos")
                                    ])
                                  : _vm._e(),
                                _vm.verificaStatusAmbiental
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "app-visualizar-monitoramento-area-tab",
                                          {
                                            attrs: {
                                              idProcesso:
                                                _vm.idProcessoMonitoramento,
                                              numeroProcesso:
                                                _vm.idNumeroProcessoMonitoramento
                                            }
                                          }
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.despachos &&
                                _vm.isPa &&
                                _vm.conversa.despacho
                                  ? _c(
                                      "div",
                                      [
                                        _c("app-despacho-simplificado", {
                                          attrs: {
                                            despachos: _vm.despachos,
                                            title:
                                              "Análise " +
                                              _vm.setoresFormatado[
                                                _vm.conversa.despacho.setor
                                              ]
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.conversaVistoriaRemota
                                  ? _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            attrs: {
                                              data: mensagem.anexoList,
                                              stripe: "stripe"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "empty" },
                                                slot: "empty"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Não há anexos disponíveis."
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c("el-table-column", {
                                              staticClass: "td-column-anexo",
                                              attrs: { prop: "nome" }
                                            }),
                                            _c("el-table-column", {
                                              staticClass: "td-column-anexo",
                                              attrs: {
                                                align: "center",
                                                width: "85"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _vm.isAp
                                                          ? _c(
                                                              "app-action-button",
                                                              {
                                                                attrs: {
                                                                  disabled: !_vm.isDocumentoParaVisualizacao(
                                                                    scope.row
                                                                  ),
                                                                  cor: !_vm.isDocumentoParaVisualizacao(
                                                                    scope.row
                                                                  )
                                                                    ? "#C0C4CC"
                                                                    : "#666666",
                                                                  text: !_vm.isDocumentoParaVisualizacao(
                                                                    scope.row
                                                                  )
                                                                    ? "Não é possível exibir esse arquivo"
                                                                    : "Visualizar",
                                                                  icone: "eye",
                                                                  fontSize: "18"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.abrirDocumento(
                                                                      scope.row
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "app-action-button",
                                                          {
                                                            attrs: {
                                                              icone: "download",
                                                              nome:
                                                                "file_download",
                                                              hoverColor:
                                                                "#009f61",
                                                              text:
                                                                "Baixar anexo"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.baixarAnexo(
                                                                  scope.row
                                                                )
                                                              }
                                                            }
                                                          }
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "buttons" },
                                  [
                                    !(_vm.conversa.status === "ENCERRADA") &&
                                    _vm.conversaNotificacaoDocumentoInvalido
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "default" },
                                            on: {
                                              click: function($event) {
                                                return _vm.$router.push({
                                                  name: "caixa-entrada"
                                                })
                                              }
                                            }
                                          },
                                          [_vm._v("Cancelar")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                mensagem.dataLimiteResposta &&
                                (_vm.conversa.despacho ||
                                  _vm.conversaVistoriaRemota) &&
                                _vm.getAssuntoMensagem()
                                  ? _c("div", { staticClass: "dataLimite" }, [
                                      _c("b", [
                                        _vm._v(
                                          "Data limite para resposta: " +
                                            _vm._s(
                                              mensagem.dataLimiteFormatada
                                            ) +
                                            "  "
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          !(_vm.conversa.status === "ENCERRADA") &&
                          !_vm.conversa.isPossivelResponder &&
                          !_vm.conversaNotificacaoDocumentoInvalido &&
                          !_vm.conversaVistoriaRemota
                            ? _c("app-resposta", {
                                attrs: {
                                  showAnexos:
                                    _vm.conversa &&
                                    _vm.conversaNotificacaoDocumentoInvalido
                                      ? false
                                      : true
                                },
                                on: { mensagemRespondida: _vm.buscarConversa }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44d327b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44d327b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppConversaMensagens.vue
// module id = null
// module chunks = 